import { Component, OnInit, OnDestroy } from '@angular/core';
import { GlobalLoaderService } from '../../../Services/global-loader/global-loader.service';

@Component({
  selector: 'app-global-loader',
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.scss']
})
export class GlobalLoaderComponent implements OnInit, OnDestroy {

  loading: boolean;
  private loadServiceSubscriber;

  constructor(private loaderService: GlobalLoaderService) {
    this.loadServiceSubscriber = this.loaderService.isLoading.subscribe((b) => {
      // console.log("loading obs");
      // console.log(b);
      // this should be
      // this.loading = b;
      // but changed to false so it wouldn't be activated untill all rules are done.
      this.loading = false;
    });
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    if (this.loadServiceSubscriber) {
      this.loadServiceSubscriber.unsubscribe();
    }
  }

}
